export const MAPS = {
  "ancient-spires": [
    "Ancient Spires",
    "https://static.aoe4world.com/assets/maps/ancient_spires-f6d4ed2baecb3e883eed7abbb0bc2d0cd9b0ade0b06052886455f9d903064c45.png",
  ],
  "high-view": [
    "High View",
    "https://static.aoe4world.com/assets/maps/high_view-554e3c206c2ab5de03eff825bae1782c995f43c3d49045c445c37167755dc756.png",
  ],
  "mongolian-heights": [
    "Mongolian Heights",
    "https://static.aoe4world.com/assets/maps/mongolian_heights-d2e6345c97a7d30d9bcb6349e599833ae70b1b16ea3029c10c986ecda996dc50.png",
  ],
  "dry-arabia": [
    "Dry Arabia",
    "https://static.aoe4world.com/assets/maps/dry_arabia-a38664e3a1140c77c184c56ce6ccc91b83ab9bf9e69f463621bf4acc6e663240.png",
  ],
  "mountain-pass": [
    "Mountain Pass",
    "https://static.aoe4world.com/assets/maps/mountain_pass-0b69b081bdb9f8df2c302d3ac3b8847a27f49e75631e2d677fa2f3b730d6ef04.png",
  ],
  "hill-and-dale": [
    "Hill and Dale",
    "https://static.aoe4world.com/assets/maps/hill_and_dale-7867678344511f75ca224324806ade2552c4667e89e57a2153c02fd44684ddee.png",
  ],
  "french-pass": [
    "French Pass",
    "https://static.aoe4world.com/assets/maps/french_pass-3ccf8fbacfc7a55fe17fcc69e1409fd6d067ca4394c9fedd55b9ab195c7363cb.png",
  ],
  "king-of-the-hill": [
    "King of the Hill",
    "https://static.aoe4world.com/assets/maps/king_of_the_hill-17717abfb688a8e8ea05bb4a0799dced0c13a3cfc864fa28fb6bf2d010e77180.png",
  ],
  altai: [
    "Altai",
    "https://static.aoe4world.com/assets/maps/altai-9b272a24dce7dfa3a2e60579a801e7152a4a94f041340ee81bef913d9cc70c6c.png",
  ],
  lipany: [
    "Lipany",
    "https://static.aoe4world.com/assets/maps/lipany-d1e494f8fd09007b948dee6ce146402ab57a382ca9c52265f140d668c3ea6b5e.png",
  ],
  confluence: [
    "Confluence",
    "https://static.aoe4world.com/assets/maps/confluence-4322dcd579128d990df9c6ee62f155d0f8d33d1f58fb30149af05967a3b8fdf3.png",
  ],
  "danube-river": [
    "Danube River",
    "https://static.aoe4world.com/assets/maps/danube_river-fb83fa5ec52e63c87867619e4e010bc4f32717ba99234fbc327a86e4e4d6af9d.png",
  ],
  "black-forest": [
    "Black Forest",
    "https://static.aoe4world.com/assets/maps/black_forest-d4431e88f043782a03b5d35d7bb26b515f8a0837dbc707675ac27f7afa0c7534.png",
  ],
  nagari: [
    "Nagari",
    "https://static.aoe4world.com/assets/maps/nagari-a89f44d0283a3e6ca61443994d0fbf025c41e362b0c21297bc889efe9bc91889.png",
  ],
  "boulder-bay": [
    "Boulder Bay",
    "https://static.aoe4world.com/assets/maps/boulder_bay-11f453b895a76e632a4507e57653e46ca1e6505801b413e3c3f71c20ef6b91f1.png",
  ],
};
export const mapMap = Object.fromEntries(Object.values(MAPS).map(([name, img]) => [name, img]));
